import { useMutation } from '@tanstack/react-query';
import { removeUserFromClassroom } from 'api/classroomApi';
import { queryClient } from 'App';
import LoadingButton from 'components/fantaclasse/LoadingButton';
import PropTypes from 'prop-types';
import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';

const RemoveUserModal = ({ userToRemove, setUserToRemove, setShowModal }) => {
  const removeUserMutation = useMutation({
    mutationFn: removeUserFromClassroom,
    onSuccess: data => {
      queryClient.invalidateQueries({ queryKey: ['classroomUsers'] });
      toast.success(() => (
        <span>
          <strong>{data.bannedUsers[0]}</strong> è stato rimosso dalla classe!
        </span>
      ));
    },
    onError: err => {
      toast.error(err.response?.data?.message || err.message);
    },
    onSettled: () => {
      handleCloseModal();
    }
  });

  const handleRemoveUser = async () => {
    removeUserMutation.mutate(userToRemove);
  };

  const handleCloseModal = () => {
    setUserToRemove(null);
    setShowModal(true);
  };

  return (
    <Modal
      show={userToRemove !== null}
      onHide={handleCloseModal}
      size="lg"
      centered
    >
      <Modal.Header className="p-4">
        <Modal.Title id="contained-modal-title-vcenter">
          Sei sicuro di voler rimuovere {userToRemove}?
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ul className="mb-0">
          <li>
            Una volta rimosso, l'utente non potrà mai più rientrare in questa
            classe.
          </li>
          <li>
            La squadra di {userToRemove} <strong>sarà eliminata</strong> e{' '}
            <strong>rimossa dalla classifica</strong>.
          </li>
        </ul>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCloseModal}>
          Indietro
        </Button>
        <LoadingButton
          text="Conferma"
          variant="danger"
          isLoading={removeUserMutation.isPending}
          action={handleRemoveUser}
        />
      </Modal.Footer>
    </Modal>
  );
};

RemoveUserModal.propTypes = {
  userToRemove: PropTypes.string,
  setUserToRemove: PropTypes.func.isRequired,
  setShowModal: PropTypes.func.isRequired
};

export default RemoveUserModal;
